// experts.js

// Import all expert images
import expert1 from "../assets/images/experts/1.png";
import expert2 from "../assets/images/experts/2.png";
import expert3 from "../assets/images/experts/3.png";
import expert4 from "../assets/images/experts/4.png";
import expert5 from "../assets/images/experts/5.png";
import expert6 from "../assets/images/experts/6.png";
import expert7 from "../assets/images/experts/7.png";
import expert8 from "../assets/images/experts/8.png";
import expert9 from "../assets/images/experts/9.png";
import formation1 from "../assets/images/experts/f5.png";
import formation2 from "../assets/images/experts/f1.jpg";
import formation3 from "../assets/images/experts/f2.jpg";
import formation4 from "../assets/images/experts/f3.png";
import critique from "../assets/images/experts/critique.png";
import defaultExpert from "../assets/images/experts/default-1.png";
import Banner from "../assets/images/Clandar.png";
import defaultf from "../assets/images/experts/defaultf-1.png";
import Dentiste from "../assets/images/experts/dentist.svg";
import Infirmier from "../assets/images/experts/nurse.svg";
import Kinesitherapeute from "../assets/images/experts/therapist.svg";
import Psychologist from "../assets/images/experts/therapist.svg";
import Radiography from "../assets/images/experts/radiologist.svg";
import Laboratory from "../assets/images/experts/pathologist.svg";
import Professor from "../assets/images/experts/professor.svg";
import Doctor from "../assets/images/experts/doctor.svg";
import Pharmacien from "../assets/images/experts/pharmacist.svg";
import Sage from "../assets/images/experts/sage.svg";
import Other from "../assets/images/experts/other.svg";

export const expertImages = {
  1: expert1,
  2: expert2,
  3: expert3,
  4: expert4,
  5: expert5,
  6: expert6,
  7: expert7,
  8: expert8,
  9: expert9,
  10: critique,
  11: defaultExpert,
  12: formation1,
  13: formation2,
  14: formation3,
  15: formation4,
  16: Banner,
  17: defaultf,
};

export const expertTypeIcons = {
  DENT: {
    icon: Dentiste,
    color: "#2196F3", // Dental Blue
  },
  NURSE: {
    icon: Infirmier,
    color: "#4CAF50", // Nursing Green
  },
  PHYS: {
    icon: Kinesitherapeute,
    color: "#FF9800", // Physical Therapy Orange
  },
  PSYC: {
    icon: Psychologist,
    color: "#9C27B0", // Psychology Purple
  },
  RAD: {
    icon: Radiography,
    color: "#607D8B", // Radiology Blue Grey
  },
  LAB: {
    icon: Laboratory,
    color: "#00BCD4", // Laboratory Cyan
  },
  PROF: {
    icon: Professor,
    color: "#3F51B5", // Professor Indigo
  },
  DOC: {
    icon: Doctor,
    color: "#E91E63", // Doctor Pink/Red
  },
  PHARM: {
    icon: Pharmacien,
    color: "#8BC34A", // Pharmacy Light Green
  },
  MIDW: {
    icon: Sage,
    color: "#FF5722", // Midwife Deep Orange
  },
  OTHER: {
    icon: Other,
    color: "#795548", // Other Brown
  },
};

const getExpertImagePath = (id) => expertImages[id];

export const experts = [
  {
    id: 1,
    avatar: getExpertImagePath(8),
    initials: "MA",
    name: "Dr. Jaafar Haikel",
    title: "Maladies Infectieuses",
    description: "Professeur de Médecine Spécialiste en Maladies Infectieuses",
    country: "Morocco",
    specialties: ["cardiologie", "soins intensifs"],
    followers: 1250,
    verified: true,
    institutions: ["CHU Cheikh Khalifa", "soins intensifs"],
    email: "m.Jaafar@email.com",
    phone: "+212 6XX-XXXXX",
    languages: ["Arabic", "French", "English"],
  },
  {
    id: 2,
    avatar: getExpertImagePath(6),
    initials: "SK",
    name: "Dr. Sara Khalil",
    title: "Neurologue",
    description: "Experte en troubles neurologiques et neurodégénératifs",
    country: "Tunisia",
    specialties: ["neurologie", "neurochirurgie"],
    followers: 980,
    x: "",
    linkedin: "",
    instagram: "",
    verified: true,
    institutions: ["CHU Cheikh Khalifa", "soins intensifs"],
    email: "s.khalil@email.com",
    phone: "+216 7XX-XXXXX",
    languages: ["Arabic", "French", "English"],
  },
  {
    id: 3,
    avatar: getExpertImagePath(7),
    initials: "RB",
    name: "Dr. Rachid Bennani",
    title: "Chirurgien",
    description:
      "Chirurgien orthopédique spécialisé en chirurgie mini-invasive",
    country: "Morocco",
    x: "",
    linkedin: "",
    instagram: "",
    specialties: ["chirurgie", "orthopédie"],
    followers: 1500,
    verified: true,
    institutions: ["CHU Cheikh Khalifa", "soins intensifs"],
    email: "r.bennani@email.com",
    phone: "+212 6XX-XXXXX",
    languages: ["Arabic", "French", "English"],
  },

  {
    id: 5,
    avatar: getExpertImagePath(5),
    initials: "RB",
    name: "Dr. Rachid Bennani",
    title: "Chirurgien",
    description:
      "Chirurgien orthopédique spécialisé en chirurgie mini-invasive",
    country: "Morocco",
    specialties: ["chirurgie", "orthopédie"],
    followers: 1500,
    verified: true,
    institutions: ["CHU Cheikh Khalifa", "soins intensifs"],
    email: "r.bennani@email.com",
    phone: "+212 6XX-XXXXX",
    languages: ["Arabic", "French", "English"],
  },
  {
    id: 6,
    avatar: getExpertImagePath(4),
    initials: "RB",
    name: "Dr. Rachida Bennani",
    title: "Chirurgien",
    description:
      "Chirurgien orthopédique spécialisé en chirurgie mini-invasive",
    country: "Morocco",
    specialties: ["chirurgie", "orthopédie"],
    followers: 1500,
    verified: true,
    institutions: ["CHU Cheikh Khalifa", "soins intensifs"],
    email: "r.bennani@email.com",
    phone: "+212 6XX-XXXXX",
    languages: ["Arabic", "French", "English"],
  },
];
// Helper functions remain the same
export const expertInstitutionMap = experts.reduce((acc, expert) => {
  expert.institutions.forEach((institutionId) => {
    if (!acc[institutionId]) {
      acc[institutionId] = [];
    }
    acc[institutionId].push(expert.id);
  });
  return acc;
}, {});

export const getExpertsByInstitution = (institutionId) => {
  return experts.filter((expert) =>
    expert.institutions.includes(institutionId)
  );
};

export const getInstitutionsByExpert = (expertId, institutions) => {
  const expert = experts.find((e) => e.id === expertId);
  if (!expert) return [];
  return institutions.filter((inst) => expert.institutions.includes(inst.id));
};

export const getExpertsBySpecialty = (specialty) => {
  return experts.filter((expert) => expert.specialties.includes(specialty));
};
